import { DropdownOption } from '@tcl-models/models';
import { SingleSelectComboBox } from '@tcl-boron-prefabs/single-select-combo-box';
import classnames from 'classnames';
import React from 'react';

import { ThreeColumnLayout } from '~/components/_common/ThreeColumnLayout';

import useStyles, { useLayoutStyles } from './SiteSelectionHeader.styles';

export type SiteSelectionHeaderProps = {
  options: DropdownOption[];
  value: DropdownOption | null;
  onChange: (selectedItem: DropdownOption | null) => void;
};

export const SiteSelectionHeader: React.FC<SiteSelectionHeaderProps> = ({ options, value, onChange }) => {
  const classes = useStyles();
  const layoutClasses = useLayoutStyles();

  return (
    <ThreeColumnLayout
      left={
        <div className={classnames(classes.comboBoxWrapper)}>
          <SingleSelectComboBox
            options={options}
            onChange={onChange}
            value={value}
            placeholder="Select a site"
            dropdownType="primary"
            label="Site"
            clearable={false}
          />
        </div>
      }
      classes={layoutClasses}
    />
  );
};

export default SiteSelectionHeader;
